import { PropTypes } from "prop-types";
import { FiGlobe, FiBriefcase, FiUsers, FiHome, FiSun, FiTruck, FiCpu } from "react-icons/fi";

export const CategoryLogo = ({ category }) => {
  switch (category) {
    case "Business": {
      return <FiBriefcase />;
    }
    case "People": {
      return <FiUsers />;
    }
    case "Automotive": {
      return <FiTruck />;
    }
    case "Property": {
      return <FiHome />;
    }
    case "Digital": {
      return <FiCpu />;
    }
    case "Weather": {
      return <FiSun />;
    }
    default: {
      return <FiGlobe />;
    }
  }
};

CategoryLogo.propTypes = {
  category: PropTypes.string,
};
